// extracted by mini-css-extract-plugin
export default {"wrapper":"schedules_wrapper__YR6O5","title":"schedules_title__4x2n3"};